import Parse from "parse";

type Language = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface VideoAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  title: string;
  description?: string;
  video: Parse.File;
  text?: string;
  image?: Parse.File;
  tenant: OD3_Tenant;
  order: number;
  language: Language;
}

export class Video extends Parse.Object<VideoAttributes> {
  constructor(data?: Partial<VideoAttributes>) {
    super("APP_Video", data as VideoAttributes);
  }
}

Parse.Object.registerSubclass("APP_Video", Video);
